import React from "react";
import { Box, Button, List, ListItemButton, ListItemText, Popover, TextField, Typography } from "@mui/material";
import PersonAddIcon from '@mui/icons-material/PersonAdd';

export default function EscolheUserPopover(props) {
    const {membros, action, lst, temAcessoBasico, titulo}=props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openUser = Boolean(anchorEl);
    const id = openUser ? 'simple-popover' : undefined;
    const [filtro, setFiltro] = React.useState('');
    const [lstMembro, setLstMembro] = React.useState();
    
    React.useEffect(()=>{
        // if( membros)
        {
            filtrar();
        }
    },[membros, filtro, lst])

    React.useEffect(()=>{
        if( openUser){
            buscaUser()
        }
    },[openUser])

    function buscaUser() {
        // Service.GET("/api/security/user/findAll").then(ret => {
        //     if( membros){
        //         const arr = ret.filter( r =>{
        
        //             const item = membros.find(m => r.email === m.email);
        
        //             if( item ) return false;
        //             return true;
        //         })
        //         setUsers(arr);
        //     }else{
        //         setUsers(ret);
        //     }
        // })
    }

    function filtrar() {
        if (lst) {
            let arr = [];
            for(let u of lst){
                if( membros){
                    const item = membros.find( m => m.login === u.login);
                    if( item )continue;
                }
                if(filtro && filtro.length > 2 ){
                    if( u.nome.includes(filtro)){
                        arr.push(u);
                    }
                    if( u.login.includes(filtro)){
                        arr.push(u);
                    }
                    if(u.email && u.email.includes(filtro) ){
                        arr.push(u);
                    }
                    continue;
                }
                arr.push(u);
            }
            setLstMembro(arr);
        }
      }

    const handleListItemClick = (e, item) => {        
        if( action ) action(item)
        setAnchorEl(null);
    }
    return (
        <React.Fragment>
            <Button startIcon={<PersonAddIcon />} size='small' disabled={!temAcessoBasico}
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                {titulo?titulo:"Membros"}
            </Button>
            {/* <Button aria-describedby={id} variant="outlined"
                onClick={(e) => setAnchorEl(e.currentTarget)}>
                Incluir Membro
            </Button> */}
            <Popover
                id={id}
                open={openUser}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box
                    sx={{
                        marginLeft: "5px",
                        marginRight: "5px",
                        my: 1,
                        minWidth: '300px'
                    }}>
                    <Typography sx={{ p: 2 }}>Escolha o membro</Typography>
                    <TextField id="id_filtro" label="Filtro" variant="outlined" fullWidth size='small'
                        value={filtro} onChange={(e) => setFiltro(e.target.value)}
                    />
                    <List component="nav" dense={true}
                        sx={{
                            width: '100%',
                            maxWidth: 360,
                            bgcolor: 'background.paper',
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: 180,
                            '& ul': { padding: 0 },
                        }}
                    >
                        {lstMembro && lstMembro.map((row) => (
                            <ListItemButton key={row.id}
                                onClick={(event) => handleListItemClick(event, row)}
                            >
                                <ListItemText
                                    primary={row.nome ? row.nome : (row.login)}
                                    secondary={row.email ? row.email : ""}
                                />
                            </ListItemButton>
                        ))}
                    </List>
                </Box>
            </Popover>
        </React.Fragment>
    );
}